// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__137Vo","rootCenter":"LoadMoreObserver_rootCenter__2i1Qg","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3f8qM"};